import type { Award, ExperienceEntry } from '@/types/content'

/** Career timeline, most recent first. */
export const experience: readonly ExperienceEntry[] = [
  {
    id: 'cdnu',
    period: '2026',
    role: 'IT Engineer — Data Centre Management & EdTech Development',
    organisation: 'ESIGN/UIECC — CDNU, Sangmélima',
    summary:
      'Administer the university data centre — server provisioning, virtualisation, network configuration and system monitoring — and led the frontend build of the E-Testing Suite examination platform.',
    stack: [
      'VMware', 'Linux', 'Networking', 'ReactJS', 'Monitoring',
    ],
  },
  {
    id: 'lameute',
    period: '2022 - Present',
    role: 'Designer, Full-Stack Developer & Cloud Engineer',
    organisation: 'LAMEUTE',
    summary:
      'Architect and deploy cloud infrastructure and networked platforms for multiple clients using AWS, Docker, Kubernetes and GitHub Actions pipelines; designed and delivered the Libroware LMS for ESIGN/UIECC.',
    stack: [
      'Figma', 'Linux', 'AWS', 'Docker', 'Kubernetes', 'GitHub Actions',
      'ReactJS', 'Tailwind CSS', 'ExpressJS', 'GraphQL', 'PostgreSQL', 'Prisma',
    ],
  },
  {
    id: 'autofish',
    period: 'Feb 2025 - Jul 2025',
    role: 'Graphic / UI-UX Designer — Mobile Developer',
    organisation: 'Autofish',
    summary:
      'Directed UI/UX design and mobile development of the Autofish Store marketplace application.',
    stack: ['Figma', 'GitHub', 'Tailwind CSS', 'ReactJS', 'Vite', 'Capacitor'],
  },
  {
    id: 'richenel',
    period: 'Jul 2024 - Mar 2025',
    role: 'IT Engineer — Artistic Director — Developer',
    organisation: "Richenel's AI Agency",
    summary:
      'Deployed cloud-native AWS infrastructure and led the brand identity redesign; delivered the Maguida AI platform.',
    stack: ['Figma', 'Illustrator', 'Photoshop', 'AWS', 'PHP', 'ReactJS'],
  },
]

/** Education, most recent first. */
export const education: readonly ExperienceEntry[] = [
  {
    id: 'msc',
    period: '2019 - 2024',
    role: 'MEng, Digital Engineering — Distinction (A+)',
    organisation: 'Congo-Cameroon Inter-State University, Sangmélima',
    summary:
      'CGPA 3.38/4.00, final year 3.40/4.00. Thesis: Graphic-UI/UX Design and Network Deployment of the CheckMe SaaS Solution.',
  },
  {
    id: 'gce-a',
    period: '2016 - 2018',
    role: 'GCE Advanced Level — 5/5 papers',
    organisation: 'Government Bilingual Practicing High School, Yaoundé',
  },
  {
    id: 'gce-o',
    period: '2011 - 2016',
    role: 'GCE Ordinary Level — 10/10 papers',
    organisation: 'Government Bilingual Practicing High School, Yaoundé',
  },
  {
    id: 'fslc',
    period: '2006 - 2011',
    role: 'First School Leaving Certificate',
    organisation: 'Government Bilingual Primary School, Yaoundé',
  },
]

/**
 * Certifications, shown where the template previously listed awards.
 * `period` carries the status for in-progress entries.
 */
export const awards: readonly Award[] = [
  {
    id: 'cyber',
    name: 'Certified Cybersecurity Educator Professional',
    period: 'November 2025',
    issuer: 'Red Team Leaders',
  },
  {
    id: 'scrum',
    name: 'Scrum Fundamentals — Agile Project Management',
    period: 'March 2023',
    issuer: 'ECLEE',
  },
]


/** Community and academic service. */
export const service: readonly ExperienceEntry[] = [
  {
    id: 'yeti',
    period: '2021 - 2024',
    role: 'Member & Technology Instructor',
    organisation: 'YETI — Youth Empowered by Technology and Innovation, Sangmélima',
    summary:
      'Delivered technology literacy sessions and one-to-one mentoring to secondary, high school and university students across the Sangmélima region, broadening access to digital education in an underserved semi-urban area.',
  },
  {
    id: 'ta',
    period: '2022 - 2024',
    role: 'Teaching Assistant & Web Development Contributor',
    organisation: 'ESIGN/UIECC, Sangmélima',
    summary:
      'Lectured incoming students on computer networking fundamentals and office productivity tools; contributed to the design and development of the official university website (esign.cm).',
  },
]
